import { includes } from 'lodash'
import { useSelector } from 'react-redux'

import { selectPermissions } from 'store/user'

import systemPermissions from './system-permissions'

export const isUserPermitted = (userPermissions, permissionName) =>
  includes(userPermissions, systemPermissions[permissionName])
export const useIsUserPermitted = (perm) => isUserPermitted(useSelector(selectPermissions), perm)

export default {
  isUserPermitted,
  useIsUserPermitted,
}
